import { CallHistory } from "@/interface/dataInterface";
import { useCallback, useState } from "react";
import { fetchCallLogsFromFreePBX } from "@/services/callLogsService";

/**
 * React hook for managing call history state
 * Provides on-demand fetching of call logs with loading and error states
 */
const useCallHistory = () => {
  const [callHistory, setCallHistory] = useState<CallHistory[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCallHistory = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await fetchCallLogsFromFreePBX();
      setCallHistory(data);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to fetch call history";
      setError(errorMessage);
      console.error("Error fetching call history:", err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { callHistory, isLoading, error, fetchCallHistory };
};

export default useCallHistory;
